import { render, staticRenderFns } from "./ModalDeliveryEnd.vue?vue&type=template&id=249ba1c0"
import script from "./ModalDeliveryEnd.vue?vue&type=script&lang=ts"
export * from "./ModalDeliveryEnd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports